var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col"},[_c('h5',{staticClass:"text-sm lg:text-xl font-bold text-gray-700"},[_vm._v(" Logged in user: "+_vm._s(_vm.user.Username)+" ("+_vm._s(_vm.userRoles)+") ")]),_c('h5',{staticClass:"text-sm :text-xl font-bold text-gray-700"},[_vm._v(" Timestamp: "+_vm._s(_vm.date)+" (Malaysia Time) ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }